<div class="mobile-menu-wrapper">
	<ea-button-link (onClick)="handleToggle()" name="otherServicesDropdown">
		Other Services
		<ea-toggle-link
			textWhenToggled=""
			textWhenUntoggled=""
			[isToggled]="isOtherServicesToggled"
			name="toggleProfileActions"
		>
		</ea-toggle-link>
	</ea-button-link>

	<ea-collapsible-panel [visible]="isOtherServicesToggled">
		<ul>
			@for (product of productList; track product) {
				<li>
					<ea-button-link
						(onClick)="onSetActiveProduct(product.id)"
						name="{{ product.name }}"
						buttonRole="link"
						class="navigation-menu-items"
						>{{ product.name }}
					</ea-button-link>
				</li>
			}
			@for (pathway of pathwayList; track pathway) {
				<li>
					<ea-button-link
						(onClick)="onSetActivePathway(pathway)"
						name="{{ pathway.name }}"
						buttonRole="link"
						class="navigation-menu-items"
						>{{ pathway.name }}
					</ea-button-link>
				</li>
			}
			@for (otherBenefit of consolidatedLoginBenefits; track otherBenefit) {
				<li>
					<a
						class="navigation-menu-items"
						[href]="otherBenefit.benefitPageUrl"
						id="{{ otherBenefit.benefitName }}Link"
						>{{ otherBenefit.benefitName }}</a
					>
				</li>
			}
		</ul>
	</ea-collapsible-panel>
</div>
